import { useState, useEffect, useMemo } from 'react'
import { RenderFormControl } from '../../FormControls/RenderFormControl'
import { MuiPickersUtilsProvider } from '../../../../../../../components/WidgetBuilder/UI/Components/Elements/FormControls/DatePickers'
import MomentUtils from '@date-io/moment'
import moment from 'moment'
import { setElemValue } from '../../../../../../../store/project/setElemValue'
import { updateTableRecord } from '../../../../../../../store/project/updateTableRecord'
import { shallowEqual, useDispatch, useSelector, useStore } from 'react-redux'
import { Checkbox, FormControlLabel, Popper } from '@material-ui/core'
import { loadSmartVPickList, processTableAction } from '../../../../../../../store/project/actions'
import { fromJS, List, isImmutable, Map } from 'immutable'
import clsx from 'clsx'
import { formatComponentText } from '../../../lib'
import CreateIcon from '@material-ui/icons/Create'
import { processTableValueRules } from '../../../../../../../lib/rules'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import { processCondRules } from '../../../../../../../store/project/processCondRules'
import LinearProgress from '@material-ui/core/LinearProgress'
import { formatTableCell } from '../../../../../../../lib/format'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import Dialog from '@material-ui/core/Dialog'
import { isSame } from '../../../../isSame'
import _ from 'lodash'
import { useLayoutMode } from '../../../../../../../hooks/useLayoutMode'
import { alignToFlex } from '../../../../../../../lib/common'
import { SET_STORE } from '../../../../../../../store/project/actionTypes'
// Create an editable cell renderer

const isOk = (val) => val !== null && val !== undefined

export const usePTErrorTo = (uid) =>
  useSelector((state) => {
    try {
      if (state.get('isWebBuilder')) {
        return null
      }
      const list = state.getIn(['project', 'Settings', 'sfMapping'], Map())
      if (Map.isMap(list)) {
        const sfItem = list.find((val) => isImmutable(val) && val.get('elemUID') === uid)
        if (sfItem) {
          return [sfItem.getIn(['errorTo', 'group']), sfItem.getIn(['errorTo', 'value'])].join('##')
        }
      }
    } catch (error) {
      console.error(error)
    }
    return null
  })

const PowerTableModalCheckbox = ({ value, onChange, elementClasses }) =>
  String(value) === 'true' ? (
    <CheckBoxIcon
      onClick={(event) => {
        event.stopPropagation()
        onChange({
          target: {
            value: false,
          },
        })
      }}
      className={clsx('ft--theme--PowerTable--checkbox', `${elementClasses}--checkbox`)}
    />
  ) : (
    <CheckBoxOutlineBlankIcon
      onClick={(event) => {
        event.stopPropagation()
        onChange({
          target: {
            value: true,
          },
        })
      }}
      className={clsx('ft--theme--PowerTable--checkbox', `${elementClasses}--checkbox`)}
    />
  )

const ModalRender = ({ isMulti, children }) =>
  isMulti ? (
    <Dialog
      open
      disableAutoFocus
      disableBackdropClick
      disableEnforceFocus
      disableRestoreFocus
      disableScrollLock
      BackdropProps={{
        open: false,
      }}>
      {children}
    </Dialog>
  ) : (
    children
  )

const usePowerTableColumnAlign = (styleRef, columnId) => {
  const styles = useSelector((state) => {
    let isGlobal = state.getIn(['project', 'Settings', 'styles', styleRef, 'isGlobal'])
    if (isGlobal) {
      return state.getIn(['project', 'Settings', 'styles', styleRef], Map())
    } else {
      const PageID = state.getIn(['project', 'Settings', 'styles', styleRef, 'type']) ? 'project' : state.get('page')
      return state.getIn(
        [...(PageID === 'project' ? ['project', 'Settings'] : ['pages', PageID, 'Props']), 'styles', styleRef],
        Map()
      )
    }
  })
  const layoutMode = useLayoutMode()

  return useMemo(() => {
    let colIDAlign = styles.getIn([layoutMode, `col-${columnId}`, 'textAlign'])
    let allColAlign = styles.getIn([layoutMode, 'col', 'textAlign'])

    if (colIDAlign) {
      return colIDAlign
    }
    return allColAlign
  }, [layoutMode, styles])
}

export const EditableCell = ({
  value: initialValue,
  row,
  updateRowsHeight,
  column,
  isEdit,
  setIsEdit,
  allowBulkUpdate,
  elementClasses,
  isPreview,
  state: {
    hiddenColumns,
    globalFilter,
    columnResizing: { columnWidths },
  },
  getLangMessages,
  rows,
  dataUID,
  PageUID,
  uid,
  path,
  component,
  rowInlineEdit,
  data,
  columns,
  handleTooltipClose,
}) => {
  let index = _.get(row, ['original', 'index'], _.find(data, (tableRow) => tableRow.value === row.value)?.index)
  const dispatch = useDispatch()
  const store = useStore()
  const [editModal, setEditModal] = useState(false)
  const layoutMode = useLayoutMode()
  const columnAlign = usePowerTableColumnAlign(component.getIn(['props', 'styleRef']), column.id)

  const inlineEdit = useSelector((state) => state.getIn(['rules', ...path, 'inline'], Map()))
  let formFieldStatus = useSelector((state) => {
    let status = state.getIn(
      ['formFieldStatuses', ...path, column.id, index],
      fromJS({
        status: 'initial',
      })
    )
    if (!isImmutable(status)) {
      status = fromJS({
        status: 'initial',
      })
    }
    if (status.get('status') == 'success') {
      status = status.set('error', 'Good')
    }
    return status
  }, isSame)
  const errorTo = usePTErrorTo(uid)
  const selection = useSelector(
    (state) =>
      _.compact(String(state.getIn(['state', ..._.initial(path), `${_.last(path)}-selectedItems`], '')).split(',')),
    isSame
  )
  const lookupValue = useSelector((state) => state.getIn(['state', PageUID, `lookup-${uid}`, column.id, index]), isSame)
  const bulkValue = useSelector((state) => state.getIn(['state', PageUID, `bulk-${uid}`, column.id, index]), isSame)
  const allBulkValues = useSelector((state) => state.getIn(['state', PageUID, `bulk-${uid}`], Map()), isSame)
  const hideValid = component.getIn(['props', layoutMode, 'hideValid'], false)
  const hideError = component.getIn(['props', layoutMode, 'hideError'], false)

  const [el, setEl] = useState(null)
  let { id, allowInlineEdit, reportInlineEdit, source } = column

  const metaChoices = useSelector((state) => state.getIn(['meta', 'SmartV', id], List()), isSame)
  let localValue = initialValue

  useEffect(() => {
    setValue(localValue)
  }, [localValue])

  if (bulkValue !== undefined) {
    if (isImmutable(bulkValue)) {
      bulkValue = bulkValue.toJS()
    }
    if (bulkValue) {
      localValue = formatComponentText(bulkValue)
    } else {
      localValue = bulkValue
    }
  } else if (localValue) {
    localValue = formatComponentText(localValue)
  }

  // We need to keep and update the state of the cell normally
  const [pushValue, setPushValue] = useState()
  const [value, setValue] = useState(localValue)
  const [isMultipleUpdate, setMultipleUpdate] = useState(false)
  const [isShowProgress, setIsShowProgress] = useState(false)

  useEffect(() => {
    if (isPreview) {
      if (bulkValue === undefined) {
        let localValue = initialValue
        if (localValue) {
          localValue = formatComponentText(localValue)
        }
        setValue(localValue)
      } else {
        if (isImmutable(bulkValue)) {
          bulkValue = bulkValue.toJS()
        }
        if (bulkValue) {
          localValue = formatComponentText(bulkValue)
        } else {
          localValue = bulkValue
        }
        setValue(localValue)
      }
    }
  }, [bulkValue])

  if (!isPreview || (rowInlineEdit !== null && rowInlineEdit !== undefined ? !rowInlineEdit : !allowInlineEdit)) {
    return <div dangerouslySetInnerHTML={{ __html: formatTableCell(localValue, column.meta) }}></div>
  }

  const onStartEdit = (e) => {
    if (allowBulkUpdate) {
      return false
    }

    let state = store.getState()
    let allStatuses = state.getIn(['formFieldStatuses', ...path], Map())
    let isFoundError = false
    try {
      allStatuses.map((row, colID) => {
        if (colID == id) {
          if (isImmutable(row)) {
            row.map((status, ind) => {
              if (String(ind) !== String(index) && isImmutable(status)) {
                if (status.getIn(['status']) === 'error') {
                  isFoundError = true
                }
              }
            })
          }
        }
      })
    } catch (err) {
      console.error(err)
    }
    if (isFoundError && isEdit) {
      return false
    }

    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }

    if ((isPreview && !isEdit) || isEdit !== `${id}__${index}`) {
      setValue(localValue)
      setMultipleUpdate(false)
      setEl(e.currentTarget)
      setIsEdit(`${id}__${index}`)
      if ((column.fieldType === 'multipicklist' || column.fieldType === 'picklist') && metaChoices.size === 0) {
        dispatch(loadSmartVPickList('PowerTable', uid, PageUID))
      }
    }
  }

  if (
    allowBulkUpdate &&
    (column.fieldType === 'multipicklist' || column.fieldType === 'picklist') &&
    metaChoices.size === 0
  ) {
    if (!window.isGetPickList) {
      window.isGetPickList = {}
    }

    if (!window.isGetPickList[`${uid}-${id}`]) {
      dispatch(loadSmartVPickList('PowerTable', uid, PageUID))
      window.isGetPickList[`${uid}-${id}`] = true
    }
  }

  // We'll only update the external data when the input is blurred
  const onClose = (evt, isSkipValidation, isClearValidation = false) => {
    let state = store.getState()
    let allStatuses = state.getIn(['formFieldStatuses', ...path], Map()).toJS()
    if (!isSkipValidation) {
      if (evt || _.get(allStatuses, [column.id, index, 'status']) === 'error') {
        let localValue = row.original?.[column.id]
        if (localValue) {
          localValue = formatComponentText(localValue)
        }
        setValue(localValue)
        if (allowBulkUpdate || selection.length > 1) {
          dispatch(setElemValue('', localValue, 'PowerTable', [PageUID, 'bulk-' + (dataUID || uid), id], true, index))
          _.map(columns, (col) => {
            if (col.id === column.id) {
              dispatch(processTableValueRules(uid, column.id, path, index, localValue, false, component))
            } else if (col.allowInlineEdit) {
              dispatch(processTableValueRules(uid, col.id, path, index, localValue, false, component))
            }
          })
        } else {
          dispatch(setElemValue('', localValue, 'PowerTable', [PageUID, dataUID || uid, id], true, index))
          dispatch(processTableValueRules(uid, column.id, path, index, localValue, true, component))
        }
      }
    }
    if (isClearValidation) {
      const clearStatuses = () => (dispatch, getState) => {
        let state = getState()
        let allStatuses = state.getIn(['formFieldStatuses', ...path], Map()).toJS()
        _.each(allStatuses, (val, key) => {
          state = state.setIn(['formFieldStatuses', ...path, key], Map())
        })
        dispatch({
          type: SET_STORE,
          payload: {
            store: state,
          },
        })
      }
      setTimeout(() => {
        dispatch(clearStatuses())
        state = store.getState()
        allStatuses = state.getIn(['formFieldStatuses', ...path], Map()).toJS()
      }, 100)
    }

    if (evt) {
      setValue(localValue)
    }
    setIsEdit(false)
    setEl(null)
    if (evt && typeof evt.preventDefault === 'function') {
      setEditModal(false)
    }
  }

  const onApply = (localValue, localLabel, isCloseModal = false, isSkipValidation = false) => {
    // if (allowBulkUpdate && !(editModal && allowBulkUpdate && column.fieldType == 'boolean')) {
    //     return true;
    // }
    if (localValue === undefined || localValue === null) {
      if (['multipicklist', 'picklist'].indexOf(column.fieldType) > -1) {
        localValue = pushValue
      } else {
        localValue = value
      }
    }

    if (formFieldStatus.get('status', 'initial') === 'error') {
      return false
    }
    if (localValue === initialValue && !(isMultipleUpdate || column.fieldType == 'boolean')) {
      return void onClose(null, isSkipValidation)
    }
    if (moment.isMoment(localValue)) {
      localValue = localValue.format()
    }
    let ids = []
    if (selection.length && isMultipleUpdate) {
      // ids = selection;
      _.each(data, function (row, rowIndex) {
        const index = selection.indexOf(_.get(row, ['value']))
        if (index > -1 && inlineEdit.getIn([id, `r${_.get(row, ['index'], rowIndex)}`], true)) {
          ids.push(_.get(row, ['valueFTHash']))
        }
      })
      _.each(selection, (k) => {
        const rowData = _.find(data, (row) => row.value === k)
        if (rowData && inlineEdit.getIn([id, `r${_.get(rowData, ['index'], index)}`], column.allowInlineEdit)) {
          if ((allowBulkUpdate && editModal) || (allowBulkUpdate && column.fieldType === 'boolean')) {
            dispatch(setElemValue('', localValue, 'PowerTable', [PageUID, `bulk-${uid}`, id], true, rowData.index))
            if (['reference', 'multipicklist', 'picklist'].indexOf(column.fieldType) > -1) {
              dispatch(
                setElemValue(
                  '',
                  localValue,
                  'PowerTable',
                  [PageUID, 'bulk-' + (dataUID || uid), `${id}-value`],
                  true,
                  rowData.index
                )
              )
            }
          } else {
            dispatch(setElemValue('', localValue, 'PowerTable', [PageUID, dataUID || uid, id], true, rowData.index))
            dispatch(setElemValue('', undefined, 'PowerTable', [PageUID, `bulk-${uid}`, id], true, rowData.index))
          }
        }
      })
    } else {
      ids = []
      _.each(data, function (eachRow) {
        if (_.get(eachRow, ['valueFTHash']) === _.get(row, ['original', 'valueFTHash'])) {
          ids.push(_.get(eachRow, ['valueFTHash']))
        }
      })
    }
    let colID = `PowerTableWidget:${dataUID || uid}#-#${PageUID === 'project' ? path[0] : PageUID}:${dataUID || uid}:${id}`
    if (source == 'report') {
      if (reportInlineEdit && reportInlineEdit.length) {
        dispatch(processTableAction(reportInlineEdit, dataUID || uid, index, 'PowerTable'))
      }
    } else {
      if (ids.length) {
        setIsShowProgress(true)
        if (
          (!isMultipleUpdate || column.fieldType == 'boolean') &&
          !(allowBulkUpdate && column.fieldType === 'boolean')
        ) {
          _.each(ids, (k) => {
            // const row = _.find(rows, row => row.original.valueFTHash === k)
            const rowData = _.find(data, (row) => _.get(row, ['valueFTHash']) === k)
            if (rowData) {
              let val = isOk(localLabel) ? localLabel : localValue
              dispatch(
                setElemValue(
                  '',
                  val,
                  'PowerTable',
                  [PageUID === 'project' ? path[0] : PageUID, dataUID || uid, id],
                  true,
                  rowData.index
                )
              )
              dispatch(
                setElemValue(
                  '',
                  undefined,
                  'PowerTable',
                  [PageUID === 'project' ? path[0] : PageUID, `bulk-${uid}`, id],
                  true,
                  rowData.index
                )
              )
            }
          })
        } else {
          _.each(ids, (k) => {
            // const row = _.find(rows, row => row.original.valueFTHash === k)
            const rowData = _.find(data, (row) => _.get(row, ['valueFTHash']) === k)
            if (rowData) {
              if ((allowBulkUpdate && editModal) || (allowBulkUpdate && column.fieldType === 'boolean')) {
                let val = localLabel
                if (isOk(localLabel)) {
                  val = localLabel
                } else if (isOk(localValue)) {
                  val = localValue
                } else if (isOk(value)) {
                  val = value
                } else {
                  val = initialValue
                }

                if (['multipicklist', 'picklist'].indexOf(column.fieldType) > -1) {
                  dispatch(
                    setElemValue(
                      '',
                      val,
                      'PowerTable',
                      [PageUID === 'project' ? path[0] : PageUID, 'bulk-' + (dataUID || uid), `${id}-value`],
                      true,
                      rowData.index
                    )
                  )
                  dispatch(
                    setElemValue(
                      '',
                      localLabel || value || localValue || initialValue,
                      'PowerTable',
                      [PageUID === 'project' ? path[0] : PageUID, `bulk-${uid}`, id],
                      true,
                      rowData.index
                    )
                  )
                } else if (['reference'].indexOf(column.fieldType) > -1) {
                  dispatch(
                    setElemValue(
                      '',
                      localLabel || value || localValue || initialValue,
                      'PowerTable',
                      [PageUID === 'project' ? path[0] : PageUID, 'bulk-' + (dataUID || uid), `${id}-value`],
                      true,
                      rowData.index
                    )
                  )
                  dispatch(
                    setElemValue(
                      '',
                      val,
                      'PowerTable',
                      [PageUID === 'project' ? path[0] : PageUID, `bulk-${uid}`, id],
                      true,
                      rowData.index
                    )
                  )
                } else {
                  dispatch(
                    setElemValue(
                      '',
                      val,
                      'PowerTable',
                      [PageUID === 'project' ? path[0] : PageUID, `bulk-${uid}`, id],
                      true,
                      rowData.index
                    )
                  )
                }
              } else {
                dispatch(
                  setElemValue(
                    '',
                    localLabel || value || localValue || initialValue,
                    'PowerTable',
                    [PageUID === 'project' ? path[0] : PageUID, dataUID || uid, id],
                    true,
                    rowData.index
                  )
                )
                dispatch(
                  setElemValue(
                    '',
                    localLabel || value || localValue || initialValue,
                    'PowerTable',
                    [PageUID === 'project' ? path[0] : PageUID, `bulk-${uid}`, id],
                    true,
                    rowData.index
                  )
                )
              }
            }
          })
        }
        if (!(allowBulkUpdate && editModal) && !(allowBulkUpdate && column.fieldType === 'boolean')) {
          dispatch(updateTableRecord(localValue, dataUID || uid, ids, colID, errorTo)).then((status) => {
            setIsShowProgress(false)
            if (status) {
              localValue = initialValue
            }
          })
        }
      }
    }

    if (selection.length && isMultipleUpdate) {
      _.each(selection, (k) => {
        const rowData = _.findIndex(data, (row) => row.value === k)
        if (rowData) {
          dispatch(
            processCondRules(
              dataUID || uid,
              null,
              [PageUID === 'project' ? path[0] : PageUID, dataUID || uid, id],
              rowData.index
            )
          )
        }
      })
    } else {
      dispatch(
        processCondRules(dataUID || uid, null, [PageUID === 'project' ? path[0] : PageUID, dataUID || uid, id], index)
      )
    }

    onClose(null, isSkipValidation)
    if (isCloseModal) {
      setEditModal(false)
    }
  }

  const onBlur = (localValue, localLabel) => {
    // if (selection.length == 1) {
    //     return false;
    // }
    let localPushValue
    if (['reference'].indexOf(column.fieldType) > -1) {
      if (!localValue) {
        localPushValue = pushValue
        localValue = value
      } else {
        localPushValue = localValue.ft_value
        localValue = localValue.ft_text
      }
      if (!localLabel) {
        localLabel = localValue
      }
    } else if (['time', 'date', 'datetime'].indexOf(column.fieldType) > -1) {
      if (!localValue) {
        localValue = value
      }
      if (moment.isMoment(localValue)) {
        localValue = localValue.format()
      } else {
        localValue = localValue
      }
      localPushValue = localLabel
    } else if (['multipicklist', 'picklist'].indexOf(column.fieldType) > -1) {
      if (column.fieldType == 'multipicklist' && localValue == '') {
        localValue = null
      }
      if (localValue === null) {
        localPushValue = undefined
        localValue = ''
      } else if (!localValue || allowBulkUpdate || editModal) {
        if (localValue && localValue.value) {
          localPushValue = localValue.value
          localValue = localValue.label
        } else if (!localValue) {
          localPushValue = pushValue
          localValue = value
        } else if (!localPushValue && localValue) {
          localPushValue = localValue
        }
      } else {
        if (localValue.value) {
          localPushValue = localValue.value
          localValue = localValue.label
        } else {
          localPushValue = localValue
          localValue = localValue
        }
      }
    } else {
      if (localValue === undefined) {
        localValue = value
      }
      if (moment.isMoment(localValue)) {
        localValue = localValue.format()
      }
    }
    if (allowBulkUpdate || selection.length > 1) {
      // if (localValue !== initialValue) {
      setValue(localValue)
      setPushValue(localPushValue)
      if (!editModal) {
        dispatch(setElemValue('', true, 'FormField', [PageUID, (dataUID || uid) + '-PowerTableBatchChanged'], true))
        dispatch(setElemValue('', localValue, 'PowerTable', [PageUID, 'bulk-' + (dataUID || uid), id], true, index))
        if (['reference', 'multipicklist', 'picklist'].indexOf(column.fieldType) > -1) {
          dispatch(
            setElemValue(
              '',
              localPushValue,
              'PowerTable',
              [PageUID, 'bulk-' + (dataUID || uid), `${id}-value`],
              true,
              index
            )
          )
        }
      }
      _.map(columns, (col) => {
        if (col.id === column.id) {
          formFieldStatus = fromJS(
            dispatch(processTableValueRules(uid, column.id, path, index, localValue, false, component))
          )
        } else if (col.allowInlineEdit) {
          let value = allBulkValues.getIn([col.id, index])
          if (value === undefined || value === null) {
            value = row.original?.[col.id]
          }
          dispatch(processTableValueRules(uid, col.id, path, index, value, false, component))
        }
      })
      dispatch(
        processCondRules((dataUID || uid) + '-PowerTableBatchChanged', null, [
          PageUID,
          (dataUID || uid) + '-PowerTableBatchChanged',
        ])
      )
      // }
      return false
    }
    if (localValue === initialValue && formFieldStatus.get('status', 'initial') !== 'error') {
      return void onClose()
    }

    formFieldStatus = fromJS(dispatch(processTableValueRules(uid, column.id, path, index, localValue, true, component)))
    updateRowsHeight()
    if (selection.length <= 1) {
      if (localLabel) {
        if (_.isArray(localLabel)) {
          localLabel = localLabel.join(';')
        }
        dispatch(setElemValue('', localLabel, 'PowerTable', [PageUID, dataUID || uid, id], true, index))
      } else {
        dispatch(setElemValue('', localValue, 'PowerTable', [PageUID, dataUID || uid, id], true, index))
      }
      if (localPushValue) {
        if (['multipicklist', 'picklist', 'reference'].indexOf(column.fieldType) > -1) {
          onApply(localPushValue, localValue, null, true)
        } else {
          onApply(localPushValue, null, null, true)
        }
      } else {
        onApply(localValue, null, null, true)
      }
      if (formFieldStatus.get('status', 'initial') !== 'error') {
        onClose(null, true)
      }
    }
  }

  let helperText = formFieldStatus.get('error', '')
  if (formFieldStatus.get('status', 'initial') === 'error' && hideError) {
    helperText = ''
  } else if (formFieldStatus.get('status', 'initial') === 'success' && hideValid) {
    helperText = ''
  }

  let inputElem = (
    <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
      <RenderFormControl
        key={id}
        label={''}
        themeKey="PowerTableField"
        value={lookupValue || value || ''}
        // isAutoFocus={!allowBulkUpdate}
        allowBulkUpdate={allowBulkUpdate}
        isMultiSelection={selection.length > 1}
        isPowerTable={true}
        onBlur={onBlur}
        onChange={(evt) => {
          if (['reference'].indexOf(column.fieldType) > -1) {
            if (evt.target.value) {
              setValue(evt.target.value.ft_text)
              setPushValue(evt.target.value.ft_value)
            } else {
              setValue('')
              setPushValue('')
            }
          } else if (['multipicklist', 'picklist'].indexOf(column.fieldType) > -1) {
            if (evt.target.value) {
              if (column.fieldType == 'multipicklist') {
                setValue(String(evt.target.label))
                setPushValue(evt.target.value.value)
              } else {
                setValue(evt.target.value.label)
                setPushValue(evt.target.value.value)
              }
            } else {
              setValue('')
              setPushValue(undefined)
            }

            typeof handleTooltipClose === 'function' && handleTooltipClose()
          } else {
            setValue(evt.target.value)
          }
        }}
        index={index}
        placeholder=""
        column={column}
        row={row}
        type={column.fieldType}
        allowClear={column?.meta?.allowClear ?? false}
        field={id}
        widgetUID={uid}
        styleKey={elementClasses}
        fullWidth
        PageUID={PageUID}
        onOpen={() => {
          if (
            selection.length > 1 &&
            allowBulkUpdate &&
            ['time', 'datetime', 'date'].includes(column.fieldType) &&
            !editModal
          ) {
            setEditModal(true)
            return true
          }
          return false
        }}
        onFocus={(event) => {
          if (selection.length > 1 && allowBulkUpdate) {
            setEditModal(true)
          }
        }}
        {...(column?.meta?.format?.mask ? { mask: column?.meta?.format?.mask } : {})}
        error={formFieldStatus.get('status', 'initial') === 'error'}
        helperText={helperText}
        rulesClasses={{
          fterror: formFieldStatus.get('status', 'initial') === 'error',
          ftsuccess: formFieldStatus.get('status', 'initial') === 'success',
        }}
        captions={component.getIn(['props', 'captions'], Map())}
      />
    </MuiPickersUtilsProvider>
  )

  if (column.fieldType == 'boolean') {
    inputElem = (
      <PowerTableModalCheckbox
        value={value}
        elementClasses={elementClasses}
        onChange={(event) => {
          setValue(event.target.value)
          onBlur(event.target.value)
        }}
      />
    )
  }

  let editUI = null
  if (allowBulkUpdate || isEdit == `${id}__${index}` || editModal) {
    editUI = (
      <ModalRender isMulti={(selection.length > 1 && !allowBulkUpdate) || editModal}>
        <div
          className={clsx('power-table-bulk-edit', 'ft--theme--PowerTable--editDlg', `${elementClasses}--editDlg`, {
            single_edit: (allowBulkUpdate || selection.length <= 1) && !editModal,
            lookup_edit: column.fieldType == 'reference',
          })}
          style={{ '--column-align': columnAlign }}>
          {inputElem}
          {((!allowBulkUpdate && selection.length > 1) || editModal) && (
            <>
              <div className="bulk-label">
                <FormControlLabel
                  id={`control${uid}-label`}
                  classes={{
                    label: clsx(`ft--label`, 'ft--theme--PowerTable--chkxLbl', `${elementClasses}--chkxLbl`),
                    // shrink: 'ft--shrink'
                  }}
                  control={
                    <Checkbox
                      classes={{
                        root: clsx('bulk-checkbox', 'ft--theme--PowerTable--checkbox', `${elementClasses}--checkbox`),
                        checked: clsx('ft--theme--PowerTable--checkbox', `${elementClasses}--checkbox`),
                      }}
                      checked={isMultipleUpdate}
                      onChange={(event, checked) => {
                        setMultipleUpdate(checked)
                      }}
                      disableTouchRipple
                      disableFocusRipple
                      disableRipple
                      color="inherit"
                      size="small"
                      id={`multipl_update_${id}`}
                      aria-labelledby={`control${id}-label`}
                    />
                  }
                  label={getLangMessages('updateCountMsg').replace('{count}', selection.length)}
                />
              </div>
              <div>
                <hr className={clsx('ft--theme--PowerTable--divider', `${elementClasses}--divider`)} />
              </div>
              <div className="btn-root">
                <button
                  type="button"
                  className={clsx('btn-cancel', 'ft--theme--PowerTable--cancel', `${elementClasses}--cancel`)}
                  onClick={(event) => onClose(event, false, true)}>
                  {getLangMessages('Cancel')}
                </button>
                <button
                  type="button"
                  className={clsx('btn-apply', 'ft--theme--PowerTable--apply', `${elementClasses}--apply`)}
                  onClick={(evt) => onApply(undefined, undefined, true)}>
                  {getLangMessages('Apply')}
                </button>
              </div>
            </>
          )}
        </div>
      </ModalRender>
    )
  }

  const onBooleanChange = (value, isSkipOpenModal = false) => {
    if (selection.length > 1 && !isSkipOpenModal) {
      return setEditModal(true)
    }
    setValue(value)
    onApply(value)
    if ((allowBulkUpdate || selection.length > 1) && !(allowBulkUpdate && column.fieldType == 'boolean')) {
      setPushValue(value)
      dispatch(setElemValue('', true, 'FormField', [PageUID, (dataUID || uid) + '-PowerTableBatchChanged'], true))
      if (allowBulkUpdate) {
        dispatch(setElemValue('', value, 'PowerTable', [PageUID, 'bulk-' + (dataUID || uid), id], true, index))
      }
      if (['reference', 'multipicklist', 'picklist'].indexOf(column.fieldType) > -1) {
        dispatch(
          setElemValue('', value, 'PowerTable', [PageUID, 'bulk-' + (dataUID || uid), `${id}-value`], true, index)
        )
      }
      formFieldStatus = fromJS(dispatch(processTableValueRules(uid, column.id, path, index, value, false, component)))
      dispatch(
        processCondRules((dataUID || uid) + '-PowerTableBatchChanged', null, [
          PageUID,
          (dataUID || uid) + '-PowerTableBatchChanged',
        ])
      )
    }
  }

  // if (isEdit != `${id}__${index}` || selection.length > 1) {
  return (
    <>
      {(!editUI || (editUI && column.fieldType == 'boolean')) && (
        <div className="powerEditableColWrap">
          {column.fieldType == 'boolean' && (
            <>
              <div
                className="powerEditableCol"
                // onClick={onStartEdit}
              >
                {String(localValue) === 'true' ? (
                  <CheckBoxIcon
                    onClick={(event) => {
                      event.stopPropagation()
                      onBooleanChange(false)
                    }}
                    className={clsx('ft--theme--PowerTable--checkbox', `${elementClasses}--checkbox`)}
                  />
                ) : (
                  <CheckBoxOutlineBlankIcon
                    onClick={(event) => {
                      event.stopPropagation()
                      onBooleanChange(true)
                    }}
                    className={clsx('ft--theme--PowerTable--checkbox', `${elementClasses}--checkbox`)}
                  />
                )}
              </div>
            </>
          )}
          {column.fieldType != 'boolean' && (
            <div
              className="powerEditableCol"
              style={{ '--column-align': columnAlign, '--column-justify': alignToFlex(columnAlign) }}
              onClick={onStartEdit}
              dangerouslySetInnerHTML={{
                __html: isEdit === `${id}__${index}` ? '' : formatTableCell(localValue, column.meta),
              }}></div>
          )}
          <div onClick={onStartEdit}>
            <CreateIcon className="icon-edit-col" />
          </div>

          {isShowProgress && !allowBulkUpdate && (
            <div className="quite-table-row-update-progress">
              <LinearProgress
                disableShrink
                classes={{
                  colorPrimary: 'ft--color-primary',
                  bar: 'ft--bar',
                }}
              />
            </div>
          )}
        </div>
      )}
      {(column.fieldType != 'boolean' || (column.fieldType === 'boolean' && editModal)) && editUI}
    </>
  )
  // } else {
  //     return inputElem;
  // }
}
